<template>
  <v-card :variant="showOutline ? 'outlined' : undefined">
    <v-card-title v-if="showTitle"> Sous-tâches </v-card-title>

    <v-divider v-if="showTitle" />

    <v-list v-if="subtasks.length">
      <SubtaskItem
        v-for="subtask in subtasks"
        :key="subtask.id || subtask.name"
        :subtask="subtask"
        @remove="onRemove"
        @update="onUpdate"
      />
    </v-list>

    <v-card-text v-else class="text-grey"> Aucune sous-tâche </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { Subtask } from "@/types";
import SubtaskItem from "./SubtaskItem.vue";

const props = withDefaults(
  defineProps<{
    subtasks: Subtask[];
    showTitle?: boolean;
    showOutline?: boolean;
  }>(),
  {
    showTitle: true,
    showOutline: true,
  }
);

const { showTitle, showOutline } = props;

const emit = defineEmits<{
  (e: "remove", subtask: Subtask): void;
  (e: "update", subtask: Subtask): void;
}>();

function onRemove(subtask: Subtask) {
  emit("remove", subtask);
}

function onUpdate(subtask: Subtask) {
  emit("update", subtask);
}
</script>
